export default __webpack_public_path__ + "static/media/SEABEX.22a497e8.jpg";